import {createSlice} from '@reduxjs/toolkit';
import {baseSetValue} from "../../utils";
import {Playlist} from "../../api/types";

export interface UserSliceState {
    recentlyPlayed: Record<string, Playlist>;
}

const initialState: UserSliceState = {
    recentlyPlayed: {},
};
export const reducers = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setValue: baseSetValue<UserSliceState>()
    },
});

export const {setValue} = reducers.actions;
export default reducers.reducer;
